import { LinearProgressProps, LinearProgress } from '@material-ui/core';

export type DSLinearProgressProps = LinearProgressProps;

export const DSLinearProgress = LinearProgress;
